import { useEffect, useState } from 'react'

import { ChromeToolbarButton } from '../ChromeActions'

type Props = {
  deadline: number
  angular: boolean
  onCancel: () => void
}

/** 创作页时间线：发送前延迟倒计时与取消按钮 */
export function TimelineDeferPlaceholder({ deadline, angular, onCancel }: Props) {
  const [, setTick] = useState(0)
  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), 250)
    return () => window.clearInterval(id)
  }, [deadline])
  const leftSec = Math.max(0, Math.ceil((deadline - Date.now()) / 1000))
  const chipRound = angular ? 'rounded-none' : 'rounded-md'
  return (
    <div className="pointer-events-auto absolute inset-0 z-[2] flex flex-col items-center justify-center gap-3 bg-[color-mix(in_srgb,var(--panel)_82%,transparent)] px-3 py-4 text-center">
      <p className="text-xs font-semibold text-ink">即将发送生成请求</p>
      <p className={`text-2xl font-mono font-bold tabular-nums text-ink ${chipRound} border border-line bg-panel px-4 py-2`}>
        {leftSec}s
      </p>
      <ChromeToolbarButton type="button" onClick={onCancel}>
        取消
      </ChromeToolbarButton>
    </div>
  )
}
